import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'stacode': {
    title: 'OA审批单号',
    type: 'input',
  }
}

export default {
  // 'cntrno': {
  //   title: '合同单号',
  //   type: 'input',
  //   equation: all,
  //   slot: true
  // },
  'cnrtln': {
    title: '单据编号',
    type: 'input',
    equation: all,
    width: 140
  },
  // 'cntrname': {
  //   describe: true,
  //   title: '合同名称',
  //   type: 'select',
  //   equation: city,
  //   dictionary: 'A0051',
  //   width: 180
  // },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  // 'contr_year': {
  //   title: '合同年度',
  //   type: 'year',
  //   equation: city
  // },
  'name1': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'customertype': {
    title: '客户类型'
  },
  'salcnter_des': {
    title: '营销单元'
  },
  'channel': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0050',
    slot: true,
    width: 200
  },
  'chfl': {
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    slot: true,
    width: 200
  },
  'sales_emp_name': {
    title: '历史计划量',
  },
  'status': {
    title: '开票数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_qty': {
    title: '发货数量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_amt1': {
    title: '违规数量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_amt2': {
    title: '参考量',
    width: 230,
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_amt': {
    title: '分配计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'address': {
    title: '状态',
    equation: all,
    type: 'input',
  },
}



// WEBPACK FOOTER //
// ./src/views/qy-manage/config/salePlanSubmit.js